import { render, staticRenderFns } from "./OSSLicense.vue?vue&type=template&id=7556983d&scoped=true&"
import script from "./OSSLicense.vue?vue&type=script&lang=ts&"
export * from "./OSSLicense.vue?vue&type=script&lang=ts&"
import style0 from "./OSSLicense.vue?vue&type=style&index=0&id=7556983d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7556983d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
